module.exports = require("/opt/build/repo/src/utils/typography")